/**
 * @file usePrefixCls 根据前缀获取类名
 * @author zongyu
*/
import { useConfig } from '../context/config';
/**
 * 根据前缀获取类名
 *
 * @param className 类名
 * @param suffixClass 额外扩展的属性
 * @param ignoreRootCls 忽略不生成主样式
 */

export function usePrefixCls(className, suffixClass, ignoreRootCls) {
  var _useConfig = useConfig(),
      prefix = _useConfig.prefix;

  return getPrefixCls("".concat(prefix, "-").concat(className), suffixClass, ignoreRootCls);
}
export function getPrefixCls(mainClassName, suffixClass, ignoreRootCls) {
  var suffixClassNames = [];

  if (suffixClass) {
    Object.keys(suffixClass).forEach(function (key) {
      var value = suffixClass[key];

      if (value === false || value == null || value === '') {
        return;
      }

      var suffix = typeof value === 'string' || typeof value === 'number' ? "-".concat(value) : '';
      suffixClassNames.push("".concat(mainClassName, "-").concat(key).concat(suffix));
    });
  }

  return suffixClassNames.concat(ignoreRootCls ? '' : mainClassName).filter(Boolean).join(' ');
}